import {useState} from "react";
import {downloadWZFile} from "../api";
import {saveWZFile} from "../download";
import {WZDownloadFormat} from "../types";

type WZDocumentActions = {
    downloading: WZDownloadFormat | null;
    downloadError: boolean;
    download: (format: WZDownloadFormat) => Promise<void>;
};

export function useWZDocumentActions(id: number): WZDocumentActions {
    const [downloading, setDownloading] = useState<WZDownloadFormat | null>(null);
    const [downloadError, setDownloadError] = useState(false);

    async function download(format: WZDownloadFormat): Promise<void> {
        setDownloading(format);
        setDownloadError(false);

        try {
            saveWZFile(await downloadWZFile(id, format));
        } catch {
            setDownloadError(true);
        } finally {
            setDownloading(null);
        }
    }

    return {downloading, downloadError, download};
}
